
export default function HeroSpiti() {


    return (
        <div className="w-full bg-cover bg-center h-96" style={{
            backgroundImage: "url(https://images.pexels.com/photos/5324310/pexels-photo-5324310.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)"
        }}>
            <div className="flex items-center justify-center h-full w-full bg-gray-900 bg-opacity-50">
                <div className="text-center">
                    <h1 className="text-white text-2xl font-semibold uppercase md:text-6xl"><span className="text-yellow-400">Spiti Valley</span> Expedition</h1>
                    <a href="/" target="_blank" rel="noreferrer">
                        <button className="px-8 py-3 mt-10 text-lg font-semibold rounded text-yellow-700 bg-yellow-100 hover:bg-yellow-200">Get Itinerary</button>
                    </a>
                    <a href='/contact'>
                        <button className="ml-12 px-8 py-3 mt-10 text-lg font-semibold rounded text-yellow-700 bg-yellow-100 hover:bg-yellow-200">Book Now</button>
                    </a>
                </div>
            </div>
        </div>
    )
}